export const ORDER_VERSION = {
  V3: 'V3',
  'V4-ESTIMATE-ORDER': 'V4-ESTIMATE-ORDER',
} as const
